import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 233D24FC-6BAE-44C4-BE98-7178560C4A32
 * name alert-minus
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-minus.svg
 * tags
 * - Alert / Error 
 */
export const AlertMinusIcon = createSvgIcon(<><path d="M14 19C14 16.21 15.91 13.87 18.5 13.2L12 2L1 21H14.35C14.13 20.37 14 19.7 14 19M13 18H11V16H13V18M13 14H11V10H13V14M24 18V20H16V18H24Z" /></>, 'AlertMinusIcon');
export default AlertMinusIcon